var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.79663C11.6825 1.79663 14.6673 4.7814 14.6673 8.4633C14.6673 12.1452 11.6825 15.13 8.00065 15.13C4.31875 15.13 1.33398 12.1452 1.33398 8.4633C1.33398 4.7814 4.31875 1.79663 8.00065 1.79663ZM7.33398 11.13H8.66732V12.4633H7.33398V11.13ZM8.00065 4.4633C8.36884 4.4633 8.66732 4.76177 8.66732 5.12996V9.12996C8.66732 9.49815 8.36884 9.79663 8.00065 9.79663C7.63246 9.79663 7.33398 9.49815 7.33398 9.12996V5.12996C7.33398 4.76177 7.63246 4.4633 8.00065 4.4633Z",
    fill: "#DC4437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfoIcon);
export default __webpack_public_path__ + "static/media/error-info-icon.51dfcc35976b7d060320698f496a2f35.svg";
export { ForwardRef as ReactComponent };